import { render } from "./DataChangedetail.vue?vue&type=template&id=1e00f91d&scoped=true"
import script from "./DataChangedetail.vue?vue&type=script&lang=js"
export * from "./DataChangedetail.vue?vue&type=script&lang=js"

import "./DataChangedetail.vue?vue&type=style&index=0&id=1e00f91d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e00f91d"]])

export default __exports__